import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import dayjs from "dayjs";
import {deleteArrayItemByKeyValue, objectFilter} from "../../utils/misc";


class AccountList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accounts: null,
            pages: null,
            filters: {},
            filterFields: null
        };
    }

    async componentDidMount() {
        await this.retrieveAccounts();
        await this.retrieveFilterFields();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveAccounts();
        }
    }

    async retrieveFilterFields() {
        const url = 'account/update_form/';
        const api = new BaseApi();
        let params = {
            fields: JSON.stringify(
                [
                    'industries',
                    'specializations',
                ]
            )
        }
        let response = await api.get(url, params);
        let fields = response.data
        fields = deleteArrayItemByKeyValue(
            fields,
            'name',
            'submitButton'
        );
        this.setState(
            {
                filterFields: fields,
            }
        );
    }

    async retrieveAccounts() {
        const url = 'account/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        params = {...params, ...this.state.filters};
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                accounts: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async filterCallBack(filters) {
        filters = objectFilter(
            filters,
            (e) => (e !== '' || !!e)
        )
        await this.setState({
            filters: filters
        });
        await this.retrieveAccounts();
    }

    render() {
        if (!this.state.accounts || !this.state.pages || !this.state.filterFields) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Компании'}
                    url={'account'}
                    data={this.state.accounts}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    filterCallBack={this.filterCallBack.bind(this)}
                    filterFields={this.state.filterFields}
                    fields={[
                        {
                            title: 'Форма собственности',
                            name: 'ownership.nameshort',
                            visible: true,
                        },
                        {
                            title: 'Название',
                            name: 'nameshort',
                            linkPattern: '/account/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_blank',
                            visible: true,
                        },
                        {
                            title: 'Полное название',
                            name: 'namelong',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value)
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD MMM YYYY'):value)
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(AccountList)